import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { aboutHeroImage } from '@/mocks/about';

export default function Hero() {
  const { t } = useTranslation('about');
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <section className="relative w-full overflow-hidden flex items-center min-h-[336px] md:min-h-[420px] lg:min-h-[500px]">
      <img
        src={aboutHeroImage}
        alt="Cosmetic packaging manufacturing alliance campus"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50" />

      <div className="relative w-full px-4 md:px-6 lg:px-10 py-10 md:py-14">
        <div className="max-w-4xl mx-auto text-center">
          <div
            className={`inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 border border-white/15 mb-4 md:mb-6 transition-all duration-700 ${
              mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            <div className="w-1.5 h-1.5 rounded-full bg-warm-500" />
            <span className="text-xs md:text-sm font-medium text-white/80 tracking-wide uppercase">
              {t('hero.badge')}
            </span>
          </div>

          <h1
            className={`text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.1] mb-4 md:mb-6 transition-all duration-700 delay-100 ${
              mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            {t('hero.title')}
          </h1>

          <p
            className={`text-base md:text-lg text-white/70 max-w-2xl mx-auto leading-relaxed transition-all duration-700 delay-200 ${
              mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            {t('hero.subtitle')}
          </p>
        </div>
      </div>
    </section>
  );
}